/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {Pipe, PipeTransform} from '@angular/core';
import {isNumberType} from '../../+reports/preview';
import {FieldType} from '../form-generator/fields/fields.interfaces';

@Pipe({
  name: 'isNumericFieldType',
  pure: true
})
export class NumericFieldTypePipe implements PipeTransform {
  public transform(fieldType: FieldType): FieldType | string {
    return isNumberType(fieldType) ? fieldType : '';
  }
}
